import { useIntl } from 'react-intl';

import type { StoreHit } from '@/integrations/algolia/types';
import { commonMessages } from '@/messages/common';

import type { ExhibitionItem } from '../../ExhibitionList';
import { formatDate } from '../../helper';

import * as S from './PastExhibitionItem.styles';
export type PastExhibitionItemType = {
  boutique?: (StoreHit & ExhibitionItem) | null;
  imagePosition: 'left' | 'right';
  sizeType: 'first' | 'middle' | 'last' | 'firstAndLast';
};
export const PastExhibitionItem = ({
  boutique,
  imagePosition,
  sizeType,
}: PastExhibitionItemType) => {
  const { formatMessage } = useIntl();
  if (!boutique) {
    return null;
  }
  return (
    <S.StyledContainer>
      <S.BackgroundWrapper>
        <S.PastExhibitionOuter>
          <S.PastExhibitionWraper
            $imagePosition={imagePosition}
            $sizeType={sizeType}
          >
            <S.PastExhibitionLeft $imagePosition={imagePosition}>
              <S.BoutiqueName
                $imagePosition={imagePosition}
                textTransform='uppercase'
              >
                {boutique?.name}
              </S.BoutiqueName>
              <S.DateTitle $imagePosition={imagePosition}>
                {formatMessage(commonMessages.from)}{' '}
                <S.DateSpan>
                  {boutique?.startDate && formatDate(boutique?.startDate)}
                </S.DateSpan>{' '}
                {formatMessage(commonMessages.to)}{' '}
                <S.DateSpan>
                  {boutique?.endDate && formatDate(boutique?.endDate)}
                </S.DateSpan>
              </S.DateTitle>
            </S.PastExhibitionLeft>
            <S.PastExhibitionRight $imagePosition={imagePosition}>
              <S.CityTitle
                $imagePosition={imagePosition}
                color='primary'
                fontFamily='italianPlate'
                textTransform='uppercase'
              >
                {boutique?.label ?? boutique?.city}
              </S.CityTitle>
            </S.PastExhibitionRight>
          </S.PastExhibitionWraper>
        </S.PastExhibitionOuter>
      </S.BackgroundWrapper>
    </S.StyledContainer>
  );
};
